<template>
  <button class="exit-icon">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_203_693)">
        <path d="M6.01041 6.36459L18.0312 18.3854M6.01041 18.3854L18.0312 6.36459" stroke="currentColor" stroke-width="1.5"
          stroke-linecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_203_693">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </button>
</template>
<style scoped>
.exit-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 20px;
  border: none;
  padding: 0;
  background-color: transparent;
  cursor: pointer;
  color: #747474;
}

.exit-icon:hover, .exit-icon:active {
  color: #A4A4A4;
}
</style>
